/**
 * UnknownPanel — every transaction still tagged with category "unknown".
 * These need triage before they can be aggregated into a real cost centre.
 */
import { HelpCircle } from "lucide-react";
import FlaggedPanel from "./FlaggedPanel";

export default function UnknownPanel(props) {
  return (
    <FlaggedPanel
      {...props}
      filter={{ category: "unknown" }}
      title="Unknown — needs triage"
      subtitle="Rows the classifier couldn't confidently place. Reclassify them from the Review tab."
      icon={HelpCircle}
      iconBgClass="bg-amber-500"
      totalLabel="Total unknown"
      testidPrefix="ops-unknown"
      loadErrorText="Failed to load unknown transactions"
      emptyIcon={HelpCircle}
      emptyTitle="Nothing left to triage"
      emptyBody={<>Every row has a category — flip one back to <span className="font-semibold text-brand-navy">Unknown</span> in Review if you want to reclassify it.</>}
      showCostCentre={false}
    />
  );
}
